import React from 'react';

const SalesforceAdministrator = () => {
    return (
        <div className="container my-5">
            <div className="row">
                <div className="col">
                    <h1>Salesforce Administrator and App Builder Certification Training</h1>
                    <p>
                        As more businesses rely on data and analytics for everything from sales and marketing to planning and customer management, Salesforce Administrators are in high demand across nearly all industries and you can find a niche in anything from banking and software to healthcare and entertainment.
                    </p>
                    {/* <p>
                        Here is the list of some of the popular companies which work for Salesforce technologies.
                    </p>
                    <ul>
                        <li>Accenture</li>
                        <li>Capgemini</li>
                        <li>Tata Consultancy Services (TCS)</li>
                        <li>IBM</li>
                        <li>Deloitte</li>
                        <li>Cognizant</li>
                        <li>Wipro</li>
                        <li>Tech Mahindra</li>
                    </ul> */}
                </div>
            </div>
            <div className="row mt-5">
                <div className="col">
                    <h2>Table of Content</h2>
                    <ul>
                        <li>Program Overview</li>
                        <li>Program Features</li>
                        <li>Delivery Mode</li>
                        <li>Prerequisites</li>
                        <li>Target Audience</li>
                        <li>Key Learning Outcomes</li>
                        <li>Certification Details and Criteria</li>
                        <li>Course Curriculum</li>
                    </ul>
                </div>
            </div>
            <div className="row mt-5">
                <div className="col">
                    <h2>Program Overview</h2>
                    <p>
                        This Salesforce certification training course is designed to teach you how to master the concepts needed to become a Salesforce administrator and app builder. You will learn how to configure Salesforce to collect, analyze, and retrieve vital customer information and to create applications using Salesforce Lightning.
                    </p>
                </div>
            </div>
            <div className="row mt-5">
                <div className="col">
                    <h2>Program Features</h2>
                    <ul>
                        <li>110 hours of total duration of learning</li>
                        <li>50 hours of instructor-led live training</li>
                        <li>30 hours of hands-on practice with Salesforce Lightning</li>
                        <li>30 hours of Online self-paced learning</li>
                        <li>5 industry projects with 30 case studies</li>
                    </ul>
                </div>
            </div>
            <div className="row mt-5">
                <div className="col">
                    <h2>Delivery Mode</h2>
                    <p>
                        Instructor led Live online training
                    </p>
                </div>
            </div>
            <div className="row mt-5">
                <div className="col">
                    <h2>Prerequisites</h2>
                    <p>
                        There are no prerequisites for this training course, but it’s good to have experience of working as an administrator or developer.
                    </p>
                </div>
            </div>
            <div className="row mt-5">
                <div className="col">
                    <h2>Target Audience</h2>
                    <ul>
                        <li>App builders</li>
                        <li>Developers</li>
                        <li>System administrators</li>
                        <li>Sales representatives</li>
                        <li>IT managers</li>
                        <li>Product managers</li>
                    </ul>
                </div>
            </div>
            <div className="row mt-5">
                <div className="col">
                    <h2>Key Learning Outcomes</h2>
                    <p>After completing this course you will be able to:</p>
                    <ul>
                        <li>Proficient to work with objects</li>
                        <li>Good understanding of Salesforce</li>
                        <li>Ability to work Security controls</li>
                        <li>Ability to implement process automations in Salesforce</li>
                        <li>Working with Reports and Dashboards</li>
                        <li>Configure Salesforce Sales Cloud and and Service Cloud</li>
                        <li>Master in salesforce configuration</li>
                        <li>Design and develop new application in Salesforce</li>
                    </ul>
                </div>
            </div>
            <div className="row mt-5">
                <div className="col">
                    <h2>Certification Details and Criteria</h2>
                    <p>To become a Certified Salesforce Administrator and Developer, you must pass the Salesforce Administrator Exam and the Salesforce App Builder Exam.</p>
                    <p>You can pass the exams by below simple steps.</p>
                    <p>Step 1: Complete the Salesforce training course</p>
                    <p>Step 2: Visit certification.salesforce.com and register to appear two exams: Salesforce Administrator and Salesforce App Builder</p>
                    <p>Step 3: Pass both the Salesforce exams and earn your certification</p>
                </div>
            </div>
            <div className="row mt-5">
                <div className="col">
                    <h2>Course Curriculum</h2>
                    <ol>
                        <li><strong>Cloud Computing</strong>
                            <ol>
                                <li>Cloud Computing</li>
                                <li>Cloud Service Model</li>
                                <li>Virtualization in Cloud</li>
                            </ol>
                        </li>



                        <li><strong>CRM And Salesforce</strong>
                            <ol>
                                <li>CRM</li>
                                <li>Salesforce Overview</li>
                            </ol>
                        </li>



                        <li><strong>Configuration and Setup</strong>
                            <ol>
                                <li>Lightning and Classic interfaces</li>
                                <li>Salesforce Branding and UI Customization</li>
                                <li>Salesforce Themes and Branding</li>
                                <li>UI Customization</li>
                                <li>Company Profile</li>
                                <li>System Overview</li>
                                <li>Fiscal Year and Currency</li>
                                <li>User Management</li>
                                <li>Salesforce Editions and Sandboxes</li>
                                <li>Deploying Changes between orgs</li>
                            </ol>
                        </li>



                        <li><strong>Data Modelling and Lightning App Builder</strong>
                            <ol>
                                <li>Object Manager and Schema Builder</li>
                                <li>Standard Object Model</li>
                                <li>Personalizing Salesforce-Creating App</li>
                                <li>Creating Objects, Fields and Tabs</li>
                                <li>Object Relationships</li>
                                <li>Master-Detail Relationship</li>
                                <li>Lookup Relationship and Lookup Filter</li>
                                <li>Roll-Up Summary Fields</li>
                                <li>Cross Object Formula Field</li>
                                <li>Customizing Search and tab Layout</li>
                                <li>List Views</li>
                                <li>Page Layouts</li>
                                <li>Record Types</li>
                                <li>Lightning Components and Page</li>
                                <li>App Manager and AppExchange</li>
                            </ol>
                        </li>



                        <li><strong>Workflow/Process Automation</strong>
                            <ol>
                                <li>Validation Rules</li>
                                <li>Approval Process</li>
                                <li>Workflow Rules and Actions</li>
                                <li>Process Builder and Process</li>
                                <li>Flow Builder and Flow</li>
                                <li>Order of Execution</li>
                            </ol>
                        </li>



                        <li><strong>Salesforce Security</strong>
                            <ol>
                                <li>Salesforce Security Security Overview</li>
                                <li>Organization Security Settings</li>
                                <li>Organization Wide Default</li>
                                <li>Record Ownerships</li>
                                <li>Role Hierarchy</li>
                                <li>Sharing Rules</li>
                                <li>Manual Sharing</li>
                                <li>Object Permissions and Record Access</li>
                                <li>User Profiles and Permissions</li>
                                <li>Permission Sets</li>
                                <li>Restriction Rules</li>
                                <li>Setup Audit Trail</li>
                            </ol>
                        </li>



                        <li><strong>Analytics Management</strong>
                            <ol>
                                <li>Report, Type of Reports and Supporting Feature</li>
                                <li>Tabular Reports</li>
                                <li>Summary Reports</li>
                                <li>Matrix Reports</li>
                                <li>Conditional Highlighting</li>
                                <li>Report Charts</li>
                                <li>Subscribing Reports</li>
                                <li>Bucket Fields</li>
                                <li>Report Summary Formula</li>
                                <li>Report Types</li>
                                <li>Dashboards</li>
                            </ol>
                        </li>



                        <li><strong>Data Management</strong>
                            <ol>
                                <li>Duplicate Management</li>
                                <li>Data Import/Exports Methods</li>
                                <li>Salesforce Id and External Id</li>
                                <li>Data Loader</li>
                                <li>Import Wizards</li>
                                <li>DataLoader.io(MuleSoft)</li>
                                <li>Data Management Best Practices</li>
                                <li>Backing up Salesforce Data</li>
                                <li>Salesforce Content</li>
                                <li>Document Folder and File Upload</li>
                            </ol>
                        </li>



                        <li><strong>Sales and Marketing Applications</strong>
                            <ol>
                                <li>Sales Overview</li>
                                <li>Web to Lead</li>
                                <li>Lead Scoring</li>
                                <li>Auto Response Rule</li>
                                <li>Lead Conversion</li>
                                <li>Assignment Rules</li>
                                <li>Opportunity Overview</li>
                                <li>Products and Price Books</li>
                                <li>Sales Productivity Features</li>
                                <li>Campaign Management</li>
                                <li>Salesforce path</li>
                                <li>Einstein Opportunity and Lead Scoring</li>
                                <li>Sales forecast</li>
                                <li>Global Actions</li>
                            </ol>
                        </li>



                        <li><strong>Service and Support Applications</strong>
                            <ol>
                                <li>The Case Object</li>
                                <li>Case Settings</li>
                                <li>Support Process</li>
                                <li>Case Escalation Rules</li>
                                <li>Email to Case</li>
                                <li>Web to Case</li>
                                <li>Solutions</li>
                                <li>Knowledge</li>
                                <li>Ideas</li>
                                <li>Customer, Partners and Employees Communities</li>
                            </ol>
                        </li>



                        <li><strong>Productivity and Collaboration</strong>
                            <ol>
                                <li>Activity management</li>
                                <li>Chatter</li>
                                <li>Salesforce App</li>
                                <li>AppExchange
                                </li></ol>
                        </li>
                    </ol>
                </div>
            </div>
        </div>
    );
}

export default SalesforceAdministrator;
